module.exports = __webpack_public_path__ + "static/card-education-teachers-4-8d46291865f8050e14877e0d2e971f20.jpg";